import React, { useState } from "react";
import { t } from "@excalidraw/excalidraw/i18n";

import "./RoomJoin.scss";

interface RoomJoinProps {
  username: string;
  setUsername: (value: string) => void;
  onJoin: () => void;
  onLogIn: () => void;
}

const RoomJoinModal: React.FC<RoomJoinProps> = ({
  username,
  setUsername,
  onJoin,
  onLogIn,
}) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleJoin = async () => {
    if (!username.trim()) {
      return;
    }
    setIsLoading(true);
    try {
      await onJoin();
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="room-join-overlay">
      <div className="room-join-modal">
        <h2>{t("labels.liveCollaboration")}</h2>
        <div className="room-join-content">
          <input
            type="text"
            placeholder={t("labels.yourName")}
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && handleJoin()}
            className="room-join-input"
            autoFocus
          />
        </div>
        <div className="room-join-actions">
          <button
            onClick={handleJoin}
            className="room-join-btn room-join-btn-primary"
            disabled={!username.trim() || isLoading}
          >
            {isLoading ? t("labels.loadingScene") : t("buttons.confirm")}
          </button>
          <button
            onClick={onLogIn}
            className="room-join-btn room-join-btn-secondary"
          >
            {"Sign in with Skilltech Tools"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default RoomJoinModal;
